const Images = {
  logo: "/images/logo.png",
  logo_small: "/images/logo_small.png",
  play_store: "/images/playstore.png",
  apple_store: "/images/apple_store.png",
  huawei: "/images/huawei.png",
  jumia_logo: "/images/jumia_logo.png",
  compu_ghana: "/images/compu_ghana.jpg",
  melcom: "/images/melcom.jpg",
  phones: "/images/phones.png",
  samsung: "/images/samsung.png",
  techno: "/images/techno.png",
  beatbox: "/images/beatbox.png",

  // PRODUCT SLIDER
  main_slide: "/images/main_slide.jpg",
  slide_one: "/images/slide_one.jpg",
  slide_two: "/images/slide_2.png",
  slide_three: "/images/phones.png",
  slide_four: "/images/samsung.png",
  slide_five: "/images/techno.png",
  slide_six: "/images/beatbox.png",

  // TELCO LOGO
  telecel_logo: "/images/telecel_logo.png",
  mtn_momo: "/images/mtn_momo.png",
  at_cash: "/images/at_cash.png",
};

export default Images;
